
function Index({ text}) {
  return (
    <>
      <h1 className="text-uppercase mb-0">
        {text}
      </h1>
      </>
  );
}

export default Index;
